import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import device from '../helpers/device'
import refs from '../helpers/refs'

class CUpsellSlider {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.init()
  }

  init () {
    // const slides = this.component.querySelectorAll('.glide__slide') ?? []

    this.glide = new Glide(this.$refs.slider, {
      type: 'slider',
      animationDuration: device.isMobile() ? 250 : 400,
      gap: 16,
      rewind: false,
      bound: true,
      perView: this.numSlides > 3 ? 2.8 : 1.5,
      breakpoints: {
        512: {
          perView: 1.8
        },
        768: {
          perView: 2.25
        },
        1024: {
          perView: 2.35
        },
        1366: {
          perView: 2.5
        },
        1680: {
          perView: 2.5
        },
        1920: {
          perView: this.numSlides > 3 ? 2.5 : 2.25
        }
      }
    })

    this.glide.on('mount.after', () => {
      this.$refs.slider.classList.remove('opacity-0')
    })

    this.glide.on('run', () => {
      // this.setControls(this.glide.index)
      this.setControlButtons(this.glide.index)
    })

    this.glide.mount({ Controls, Keyboard, Breakpoints, Swipe })

    // Control buttons
    this.$refs.controls?.forEach((control) => {
      control.addEventListener('click', (e) => {
        // console.log('category click', e)
        const index = parseInt(control.closest('[data-index]').dataset.index)
        this.glide.go(`=${index}`)
        // this.setControls(index)
        this.setControlButtons(index)
      })
    })

    // Adding aria-hidden property to clones
    // it's ok if this is undefined - it's undefined for c-category-slide and that works
    const cloneSelector = `.${this.glide.settings.classes.cloneSlide}`
    this.$refs.slider
      .querySelectorAll(cloneSelector)
      .forEach(el => el.setAttribute('aria-hidden', 'true'))

    // this.setControls(0)
    this.setControlButtons(0)
  }

  // Set bottom controls state when using bars
  /*
  setControls (index) {
    // Slider: Upsell Slider Focus
    if (this.$refs.controls) {
      this.$refs.controls?.forEach((control) => {
        if (parseInt(control.getAttribute('data-index')) === index) {
          control.classList.add('c-upsell-slider__control-button--active')
        } else {
          control.classList.remove('c-upsell-slider__control-button--active')
        }
      })
    }
  }
  */

  // Set button controls
  setControlButtons (index) {
    if (!Array.isArray(this.$refs.prevUpsell)) {
      this.$refs.prevUpsell = [this.$refs.prevUpsell]
    }
    if (!Array.isArray(this.$refs.nextUpsell)) {
      this.$refs.nextUpsell = [this.$refs.nextUpsell]
    }

    // Button: Previous Upsell
    this.$refs.prevUpsell.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        this.glide.go('<')
      })
    })

    // Button: Next Upsell
    this.$refs.nextUpsell.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        this.glide.go('>')
      })
    })
  }
}

// Rebuild upsell slider when upsells are updated
document.addEventListener('cartUpsells:updated', () => {
  document
    .querySelectorAll('[data-c-upsell-slider-container]')
    .forEach(el => new CUpsellSlider(el))
})
